export function buildCustomEvent(event, detail, bubbles = true, ...args) {
    return new CustomEvent(
        event, {
            bubbles,
            detail,
            args,
        }
    );
}

export function getPseudoContent(el, pseudo) {
    return window.getComputedStyle(el, pseudo)
        .getPropertyValue('content')
        .replace(/"/g, '');
}

export function getCurrentBreakpoint() {
    return getPseudoContent(document.body, ':after');
}

export function debounce(fn, wait) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), (wait || 1));
    };
}


/*  ParamToObject splits the return parameter string from propay
and creates a javascript object                             */
export function paramToObject(string) {
    //remove line breaks
    string = string.replace(/(\r\n|\n|\r)/gm,"");

    let splitParams = string.split('&');

    let stringObject = {};
    splitParams.map((el) => {
        let keyValue = el.split('=');
        stringObject[keyValue[0]] = keyValue[1];
    });

    return stringObject;
}